import { inchesToFeet } from "legacy/helpers.es6"
import SearchCustomerForm from "legacy/manage/SearchCustomerForm"
import BoatChooser from "legacy/new-reservation-form/BoatChooser"
import Quote from "legacy/new-reservation-form/Quote"
import ReservationSteps from "legacy/new-reservation-form/ReservationSteps"
import Summary from "legacy/new-reservation-form/Summary"
import PropTypes from "prop-types"
import React from "react"

class NewReservationWizard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: props.page,
      arrival: props.arrival,
      departure: props.departure || undefined,
      spaceType: props.spaceType,
      loa: undefined,
      beam: undefined,
      loadingPrice: false,
      isCustomBillingSet: false,
      isRateApplied: false,
      customBilling: props.customBilling,
      rate: props.rate,
      rateType: "nightly",
      totalPrice: 0,
      priceErrorMessage: null,
      contact: props.contact || undefined,
      boat: props.boat || undefined,
      electricId: undefined,
      billingCycle: props.defaultBillingCycle,
      paymentMethod: "credit",
      confirmationEmail: true,
    }
    this.setPage = this.setPage.bind(this)
    this.goToContacts = this.goToContacts.bind(this)
    this.updateStateFromQuotePage = this.updateStateFromQuotePage.bind(this)
    this.updateStateFromSummaryPage = this.updateStateFromSummaryPage.bind(this)
    this.selectContact = this.selectContact.bind(this)
    this.selectBoat = this.selectBoat.bind(this)
    this.savedOrCustomRateApplied = this.savedOrCustomRateApplied.bind(this)
  }

  updateStateFromQuotePage(state) {
    this.setState({
      rate: { ...this.state.rate, ...state },
      ...state,
    })
  }

  updateStateFromSummaryPage(state) {
    this.setState({
      customBilling: { ...this.state.customBilling, ...state.customBilling },
      rate: { ...this.state.rate, ...state },
      ...state,
    })
  }

  savedOrCustomRateApplied() {
    return this.state.isRateApplied || this.state.isCustomBillingSet
  }

  setPage(page) {
    this.setState({ page })
  }

  goToContacts() {
    this.setPage("contact")
  }

  selectContact(contact) {
    this.setState({
      contact,
      boat: null,
      page: "boat",
    })
  }

  selectBoat(boat) {
    this.setState({
      boat,
      loa: inchesToFeet(boat.lengthOverall),
      beam: inchesToFeet(boat.beam),
      page: "summary",
    })
  }

  renderAvailabilityPage() {
    return (
      <Quote
        arrival={this.state.arrival}
        departure={this.state.departure}
        spaceType={this.state.spaceType}
        loa={this.state.loa}
        beam={this.state.beam}
        isRateApplied={this.state.isRateApplied}
        rate={this.state.rate}
        rateType={this.state.rateType}
        isCustomBillingSet={this.state.isCustomBillingSet}
        marina={this.props.marina}
        rateOptions={this.props.rateOptions}
        goToContacts={this.goToContacts}
        updateParentState={this.updateStateFromQuotePage}
      />
    )
  }

  renderCustomerPage() {
    return (
      <div className="paper-page center max-w-7xl">
        <h3 className="mt-0 font-semibold">Create New Reservation</h3>
        <SearchCustomerForm
          selectContact={this.selectContact}
          isSafeHarborLocation={this.props.isSafeHarborLocation}
          filterContactsPath={this.props.filterContactsPath}
          manageContactsPath={this.props.manageContactsPath}
          brewerImportPath={this.props.brewerImportPath}
          userImportPath={this.props.userImportPath}
        />
      </div>
    )
  }

  renderBoatPage() {
    return (
      <div className="paper-page center max-w-7xl">
        <BoatChooser
          contact={this.state.contact}
          selectedBoat={this.state.boat}
          submitBoat={this.selectBoat}
        />
      </div>
    )
  }

  renderSummaryPage() {
    return (
      <Summary
        electricId={this.state.electricId}
        arrival={this.state.arrival}
        departure={this.state.departure}
        spaceType={this.state.spaceType}
        contact={this.state.contact}
        boat={this.state.boat}
        billingCycle={this.state.billingCycle}
        billingCycles={this.props.billingCycles}
        paymentMethod={this.state.paymentMethod}
        confirmationEmail={this.state.confirmationEmail}
        discounts={this.state.discounts}
        selectedCardId={this.state.selectedCardId}
        rate={this.state.rate}
        rateType={this.state.rateType}
        isRateApplied={this.state.isRateApplied}
        isCustomBillingSet={this.state.isCustomBillingSet}
        customBilling={this.state.customBilling}
        savedOrCustomRateApplied={this.savedOrCustomRateApplied()}
        rateOptions={this.props.rateOptions}
        marina={this.props.marina}
        updateParentState={this.updateStateFromSummaryPage}
        charges={this.state.charges}
        totalPrice={this.state.totalPrice}
        waitlistId={this.props.waitlistId}
        revenueCategories={this.props.revenueCategories}
      />
    )
  }

  renderPage() {
    switch (this.state.page) {
      case "availability":
        return this.renderAvailabilityPage()
      case "contact":
        return this.renderCustomerPage()
      case "boat":
        return this.renderBoatPage()
      case "summary":
        return this.renderSummaryPage()
      default:
        return null
    }
  }

  render() {
    return (
      <div id="newReservationWizard">
        <ReservationSteps
          page={this.state.page}
          contactId={this.state.contact && this.state.contact.id}
          boatId={this.state.boat && this.state.boat.id}
          setPage={this.setPage}
        />
        {this.renderPage()}
      </div>
    )
  }
}

NewReservationWizard.propTypes = {
  arrival: PropTypes.string.isRequired,
  billingCycles: PropTypes.array,
  boat: PropTypes.object,
  brewerImportPath: PropTypes.string,
  contact: PropTypes.object,
  customBilling: PropTypes.object,
  defaultBillingCycle: PropTypes.string,
  departure: PropTypes.string,
  filterContactsPath: PropTypes.string,
  isSafeHarborLocation: PropTypes.bool,
  manageContactsPath: PropTypes.string,
  marina: PropTypes.object.isRequired,
  page: PropTypes.string.isRequired,
  rate: PropTypes.object,
  rateOptions: PropTypes.array,
  revenueCategories: PropTypes.array,
  spaceType: PropTypes.string.isRequired,
  userImportPath: PropTypes.string,
  waitlistId: PropTypes.string,
}

export default NewReservationWizard
